import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  // Function to hash data using SHA-1
  hashData(data: string): string {
    const hashedData = CryptoJS.SHA1(data).toString();
    return hashedData;
  }

  // Function to encrypt data
  encryptData(data: string, secretKey: string): string {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  }

  // Function to decrypt data
  decryptData(ciphertext: string, secretKey: string): string {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
